import { render, staticRenderFns } from "./Redis.vue?vue&type=template&id=42435717&scoped=true"
import script from "./Redis.vue?vue&type=script&lang=js"
export * from "./Redis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42435717",
  null
  
)

export default component.exports